<template>
	<div style="margin: 15px 0 12px 0">
		<slot />
	</div>
</template>

<script>
export default {}
</script>
